import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Pagination, Checkbox, Tooltip, CircularProgress, } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PhoneInTalkOutlinedIcon from "@mui/icons-material/PhoneInTalkOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import ModalForContacts, { ModalForContactSetup } from "./ModalForContacts";
import Details from "./Details";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CommonMoreActionOptionModal from "./CommonMoreActionOptionModal";
import { DeleteConatctAgentForCallingAgent, getContactAgentForCalligAgent, requestACallFromContact, requestBulkCallFromContact, requestBulkDeleteFromContact } from "../../../../../contexts/WorkspaceUtils";
import CommonToast from "../../../../Common_Components/CommonToast";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CommanModalForConformation from "../../../../Common_Components/CommanModalForConformation";
import { useWorkspace } from "../../../../../contexts/WorkspaceContext";
import VoiceCallOptionModal from "./VoiceCallOptionModal";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BulkCallConformationModal, { PreviousCallContactModal } from "./BulkCallConformationModal";
import CircularLoader from "../../Track_Website/CircularLoader";
import {
    Input,
    Popover,
    MenuItem,
    InputAdornment,
    FormControl,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const userOptions = [
  {
    label: "Edit",
    icon: <EditIcon style={{ color: 'white' }} />,
    onClick: () => console.log("Edit")
  },
  {
    label: "Delete",
    icon: <DeleteIcon style={{ color: 'white' }} />,
    onClick: () => console.log("Delete")
  },
]

const Contacts = () => {
  const [openAddContactModal, setopenAddContactModal] = useState();
  const [openUserDetails, setopenUserDetails] = useState(null);
  const [moreActionOption, setMoreActionOption] = useState(null);
  const [showContactSetupModal, setShowContactSetupModal] = useState(null);
  const [buttonClick, setButtonClick] = useState("add");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(null);
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState("success");
  const [activeUserObject, setActiveUserObject] = useState(null);
  const [openDeleteConformationModal, setOpenDeleteConformationModal] = useState(false);
  const [openBulkCallConformationModal, setOpenBulkCallConformationModal] = useState(false);
  const [showPreviousCallModal, setShowPreviousCallModal] = useState(false);
  const [deleteModalTitle, setDeleteModalTitle] = useState("Delete Contact agent?");
  const [deleteModalMsg, setDeleteModalMsg] = useState("This Contact agent will be deleted and removed from this list. This action cannot be undone. Are you sure you want to delete this Contact agent?");
  const [loading, setLoading] = useState(false);
  const [phoneCallTriggerdloading, setPhoneCallTriggerdLoading] = useState(false);
  const [loadingId, setLoadingId] = useState(null);
  const [userID, setUserID] = useState("");
  const [selectedContacts, setSelectedContacts] = useState([]);
  const [selectedContactsId, setSelectedContactsId] = useState([]);
  const [confirmTitle, setConfirmTitle] = useState("Yes, delete contact");
  const [alreadyCallHappen, setAlreadyCallHappen] = useState(false);
  const [allowRecalling, setAllowRecalling] = useState(false);
  const [pageSize, setPageSize] = useState(10);
  const {contactData, setContactData, setShowVoiceCallModal} = useWorkspace()
  const [anchorEl, setAnchorEl] = useState(null);
  const opendropdown = Boolean(anchorEl);

  const perPageItem = [
      {id:1,value:10},
      {id:2,value:20},
      {id:3,value:50},
      {id:4,value:100}
    ]
   
       const handleOpen = (event) => {
           setAnchorEl(event.currentTarget);
       };
   
       const handleClose = () => {
           setAnchorEl(null);
       };

  const HandleCloseButtonClick = () => {
    setActiveUserObject(null)
    setButtonClick("add");
    setopenAddContactModal(false);
  };

  const HandleAddContactButtonClick = () => {
    setButtonClick("add");
    setopenAddContactModal(true);
  };

  const HandleClickOnUser = (e,row) => {
    e.stopPropagation()
    setopenUserDetails(true);
    setUserID(row)
  };

  const HandleMoreOptionInActionClick = (event, object) => {
    // open more action modal here
    event.stopPropagation();
    setActiveUserObject(object)
    setMoreActionOption(event.currentTarget);
  };

  const handleContactSettingButtonClick = () => {
    setShowContactSetupModal(true);
  };

  const HandleContactSettingModalClose = () => {
    setActiveUserObject(null)
    setShowContactSetupModal(false);
  };

  const HandleUploadContactButtonClick = () => {
    setButtonClick("upload");
    setopenAddContactModal(true);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value); // Update the current page when a page is clicked
    setSelectedContacts([])
    setSelectedContactsId([])
  };

  const handleToastClose = () => {
    setOpen(false);
  };

  const getcontactsData = async () => {
    setLoading(true)
    try {
      const res = await getContactAgentForCalligAgent(currentPage, pageSize);
      const contactData = await res.json();
      if (contactData?.status) {
        // console.log("contactData", contactData?.data);
        setContactData(contactData?.data?.data);
        setTotalPages(contactData?.data?.pagination?.total_pages);
      } else {
        setOpen(true);
        setContent(contactData?.message);
        setIconType("error");
      }
    } catch (error) {
      console.log(error);
      setOpen(true);
      setContent(error?.message);
      setIconType("error");
    }
    setLoading(false)
  };

  useEffect(() => {
  const fetchData = async () => {
    await getcontactsData();
  };
  fetchData();
}, [currentPage, pageSize]);


  const theme = createTheme({
    typography: {
      fontFamily: "Inter",
    },
    components: {
      MuiPagination: {
        styleOverrides: {
          root: {
            "& .MuiPaginationItem-root": {
              color: "#ffffff",
              borderRadius: "20px",
              "&:hover": {
                backgroundColor: "rgba(179, 168, 183, 0.26)",
              },
              fontSize: "14px",
            },
            "& .MuiPaginationItem-page.Mui-selected": {
              backgroundColor: "#CAC4D0",
              color: "black",
              "&:hover": {
                backgroundColor: "#CAC4D0",
              },
            },
            "& .MuiPaginationItem-ellipsis": {
              color: "#ffffff",
            },
            "& .MuiPaginationItem-previousNext": {
              color: "#ffffff",
              borderRadius: "20px",
            },
          },
        },
      },
    },
  });


   const HandleCancelDeleteContactAgent =async () =>{
    setActiveUserObject(null)
    setOpenDeleteConformationModal(false)
    }
  
    const HandleConfirmDeleteContactAgent = async () =>{
      if(activeUserObject){
        setLoading(true)
        try{
          const jsonRespData = await DeleteConatctAgentForCallingAgent(activeUserObject?.id)
          const response = await jsonRespData.json()
          if(response?.status){
            setOpen(true);
            setContent(response?.message);
            setIconType('success');
            setActiveUserObject(null)
        }else{
          setOpen(true);
          setContent(response?.message);
          setIconType('error');
        }
        }catch(error){
          console.log(error)
          setOpen(true);
          setContent(error?.message);
          setIconType('error');
        }finally{
          setOpenDeleteConformationModal(false)
          setMoreActionOption(false)
          setLoading(false)
          await getcontactsData()
        }
      }else{
       await handleDeleteSelectedUser()
      }
    
    }

    function formatDateTime(isoString) {
      const date = new Date(isoString);
    
      const day = date.getDate();
      const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ];
      const month = monthNames[date.getMonth()];
      const year = date.getFullYear();
    
      let hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const ampm = hours >= 12 ? 'PM' : 'AM';
    
      hours = hours % 12;
      hours = hours ? hours : 12; // 0 should be 12
    
      return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
    }

    const HandleWebCallClick = (e) => {
      e.stopPropagation()
      setOpen(true);
      setContent("Coming Soon")
      setIconType('success')
    }

    const HandleVoiceCallClick =async (e, row) => {
      // console.log("row data",row)
      e.stopPropagation()
          const newObj = {
            contact_id : row?.contact_id
          }
      setPhoneCallTriggerdLoading(true)
      try{
        const res = await requestACallFromContact(newObj)
        const response = await res.json()
        if(response.status){
        setOpen(true);
        setContent(response?.message)
        setIconType('success')
        }else{
          setOpen(true);
          setContent(response?.message)
          setIconType('error')
        }
      }catch(error){
        setOpen(true);
        setContent(error?.message)
        setIconType('error') 
      }finally{
         setPhoneCallTriggerdLoading(false)
         setLoadingId(null)
      }
    }

    function convertObjectToTextFormat(input) {
      try {
        // If input is a string that looks like JSON, try to parse it
        if (typeof input === "string" && input.trim().startsWith("{")) {
          input = JSON.parse(input);
        }
    
        if (input && typeof input === "object" && !Array.isArray(input)) {
          const keys = Object.keys(input);
          if (keys.length > 0) {
            const entries = keys.map(
              (key) => `"${key}":"${String(input[key])}"`
            );
            return `{${entries.join(",")}}`;
          } else {
            return ""; // Empty object -> render nothing
          }
        } else {
          return String(input); // Primitive values or non-object input
        }
      } catch (e) {
        return String(input); // If parsing fails, return original string
      }
    }

    // const handleSelectContact = (e, contact) => {
    //   e.stopPropagation();
    //   const contactId = contact?.contact_id;
    //   const Id = contact?.id;
    
    //   if (selectedContacts.includes(contactId)) {
    //     setSelectedContacts(selectedContacts.filter(id => id !== contactId));
    //   } else {
    //     setSelectedContacts([...selectedContacts, contactId]);
    //   }
    //   if (selectedContactsId.includes(contact?.id)) {
    //     setSelectedContactsId(selectedContactsId.filter(id => id !== Id));
    //   } else {
    //     setSelectedContactsId([...selectedContactsId, Id]);
    //   }
    // };

    const handleSelectContact = (e, contact) => {
  e.stopPropagation();
  const contactId = contact?.contact_id;
  const Id = contact?.id;

  let updatedSelectedContacts = [...selectedContacts];
  let updatedSelectedContactsId = [...selectedContactsId];

  if (selectedContacts.includes(contactId)) {
    updatedSelectedContacts = updatedSelectedContacts.filter(id => id !== contactId);
    updatedSelectedContactsId = updatedSelectedContactsId.filter(id => id !== Id);
  } else {
    updatedSelectedContacts.push(contactId);
    updatedSelectedContactsId.push(Id);
  }

  setSelectedContacts(updatedSelectedContacts);
  setSelectedContactsId(updatedSelectedContactsId);

  // Check if any selected contact has bulk_call_triggered === true
  const selectedObjects = contactData.filter(c => updatedSelectedContactsId.includes(c.id));
  const anyCallTriggered = selectedObjects.some(c => c.bulk_call_triggered === true);
  setAlreadyCallHappen(anyCallTriggered);
};

      // console.log("selectedContact", selectedContacts)
  //  const handleSelectAll = (e) => {
  //     e.stopPropagation()
  //     if (e.target.checked) {
  //       const allIds = contactData?.map(contact => contact?.contact_id);
  //       setSelectedContacts(allIds);
  //     } else {
  //       setSelectedContacts([]);
  //     }
  //     if (e.target.checked) {
  //       const allIds = contactData?.map(contact => contact?.id);
  //       setSelectedContactsId(allIds);
  //     } else {
  //       setSelectedContactsId([]);
  //     }
  //   };

  const handleSelectAll = (e) => {
  e.stopPropagation();

  if (e.target.checked) {
    const allContacts = contactData?.map(contact => contact.contact_id);
    const allContactIds = contactData?.map(contact => contact.id);

    setSelectedContacts(allContacts);
    setSelectedContactsId(allContactIds);

    // Check for any call triggered
    const anyCallTriggered = contactData?.some(c => c.bulk_call_triggered === true);
    setAlreadyCallHappen(anyCallTriggered);

  } else {
    setSelectedContacts([]);
    setSelectedContactsId([]);
    setAlreadyCallHappen(false); // Deselect all = no call triggered
  }
};

// const handleDeselectTriggeredContacts = () => {
//   const filteredContacts = contactData.filter(c => !c.bulk_call_triggered);
//   const newSelectedContacts = filteredContacts.map(c => c.contact_id);
//   const newSelectedContactsId = filteredContacts.map(c => c.id);

//   setSelectedContacts(newSelectedContacts);
//   setSelectedContactsId(newSelectedContactsId);
//   setAlreadyCallHappen(false); // Since all triggered ones are removed
//   setOpenBulkCallConformationModal(true)
//   setShowPreviousCallModal(false)
// };


const handleDeselectTriggeredContacts = () => {
  // Filter to keep only selected contacts where bulk_call_triggered is false
  const filtered = contactData.filter(contact =>
    selectedContacts.includes(contact.contact_id) && !contact.bulk_call_triggered
  );

  const newSelectedContacts = filtered.map(c => c.contact_id);
  const newSelectedContactsId = filtered.map(c => c.id);

  setSelectedContacts(newSelectedContacts);
  setSelectedContactsId(newSelectedContactsId);

  // Update alreadyCallHappen flag
  const anyTriggeredLeft = filtered.some(c => c.bulk_call_triggered);
  setAlreadyCallHappen(anyTriggeredLeft); // This will usually be false now
  setOpenBulkCallConformationModal(true)
  setShowPreviousCallModal(false)
};


   
    const handleDeleteSelectedUser =async () => {
      setLoading(true)
      const newObj = {
        contact_ids : selectedContacts
      }
      try{
        const res = await requestBulkDeleteFromContact(newObj)
        const response = await res.json()
        if(response.status){
        setOpen(true);
        setContent(response?.message)
        setIconType('success')
        setSelectedContacts([])
        setSelectedContactsId([])
        await getcontactsData()
        }else{
          setOpen(true);
          setContent(response?.message)
          setIconType('error')
        }
      }catch(error){
        setOpen(true);
        setContent(error?.message)
        setIconType('error')
      }finally{
        setLoading(false)
        setOpenDeleteConformationModal(false)
      }
    };

    const handleCallSelectedUser =async () => {
      const newObj = {
        contact_ids : selectedContacts,
        allow_recalling: allowRecalling
      }
      try{
        const res = await requestBulkCallFromContact(newObj)
        const response = await res.json()
        if(response.status){
        setOpen(true);
        setContent(response?.message)
        setIconType('success')
        setSelectedContacts([])
        setSelectedContactsId([])
        handleCloseBulkCallConformationModal()
        setOpenBulkCallConformationModal(false)
        setShowPreviousCallModal(false)
        await getcontactsData()
        }else{
          setOpen(true);
          setContent(response?.message)
          setIconType('error')
        }
      }catch(error){
        setOpen(true);
        setContent(error?.message)
        setIconType('error')
      }
    };
  
    // const isAllSelected = contactData?.length > 0 && selectedContacts?.length === contactData?.length;

    const isAllSelected = selectedContacts?.length === contactData?.length && contactData?.length > 0;

    const handleDeleteAllButtonClick = () => {
      setDeleteModalTitle(`Delete ${selectedContacts?.length} contacts?`)
      setDeleteModalMsg(`All of your ${selectedContacts?.length} selected contacts will be deleted. This action cannot be undone. Do you want to proceed?`)
      setConfirmTitle(`Yes, delete ${selectedContacts?.length} contacts`)
      setOpenDeleteConformationModal(true)
    }

    const handleBulkCallButtonClick = () => {
      if(alreadyCallHappen){
        setShowPreviousCallModal(true)  
      }else{
        setOpenBulkCallConformationModal(true)
      }
    }

    const handleCloseBulkCallConformationModal = () => {
      setOpenBulkCallConformationModal(false)
    }

    const handleClosePreviousCalledContactModal = () => {
      setShowPreviousCallModal(false)
    }
    
  return (
    <>
      {openUserDetails ? (
        <Details
          name={userID?.name}
          id={userID?.id}
          setopenUserDetails={setopenUserDetails}
          place={"contact"}
        />
      ) : (
        <div>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h4" sx={{fontFamily:"Inter", fontSize:"24px", fontStyle:"normal", fontWeight:600, lineHeight:"20px", color:"#ffffff", opacity:0.90}}>Contacts</Typography>
            <Box
              sx={{ display: "flex", flexDirection: "row", columnGap: "20px" }}
            >
              <Button
                onClick={HandleAddContactButtonClick}
                sx={{
                  width: "120px",
                  maxWidth: "120px",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  bgcolor: "rgba(246, 190, 107, 1)",
                  color: "rgba(23, 24, 44, 1)",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#ffd9aa",
                  },
                  // "&.Mui-disabled": {
                  //   color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                  //   bgcolor:(subscribe && subscribeType === 4) ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  // },
                }}
              >
                Add contact
              </Button>

              <Button
                onClick={HandleUploadContactButtonClick}
                sx={{
                  width: "120px",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  color: "rgba(246, 190, 106, 1)",
                  border: "1px solid rgba(246, 190, 106, 1)",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: "#282D51",
                  },
                  // "&.Mui-disabled": {
                  //   color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
                  //   bgcolor:subscribe && subscribeType == "4" ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
                  // },
                }}
              >
                Upload CSV
              </Button>

               {/* <Button  disabled={selectedContacts.length === 0}
                onClick={handleDeleteSelectedUser}
                sx={{
                  width: "auto",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  bgcolor: "#DD2025",
                  color: "#FFFFFF",
                  padding:"10px 24px",
                  flexWrap:"nowrap",
                  borderRadius:"8px",
                  "&:hover": {
                    backgroundColor: "#E6E0E91F",
                  },
                  "&.Mui-disabled":{
                    backgroundColor: "#E6E0E91F",
                  }
                }}
              >
                Delete Selected Contacts
              </Button>
              <Button  disabled={selectedContacts.length === 0}
                onClick={handleCallSelectedUser}
                sx={{
                  width: "auto",
                  height: "40px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 600,
                  textAlign: "center",
                  bgcolor: "#DD2025",
                  color: "#FFFFFF",
                  padding:"10px 24px",
                  flexWrap:"nowrap",
                  borderRadius:"8px",
                  "&:hover": {
                    backgroundColor: "#E6E0E91F",
                  },
                  "&.Mui-disabled":{
                    backgroundColor: "#E6E0E91F",
                  }
                }}
              >
                Call Selected Contacts
              </Button>  */}

              {/* <Button
                onClick={handleContactSettingButtonClick}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  borderRadius: "50%",
                  alignItems: "center",
                  maxWidth: "36px",
                  minWidth: "36px",
                  height: "36px",
                  padding: "0px",
                }}
              >
                <SettingsOutlinedIcon
                  sx={{ color: "#CAC4D0", width: "20px", height: "20px" }}
                />
              </Button> */}
            </Box>
          </Box>
          <Box>
            <FormControl>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                
                {/* Label */}
                <Typography 
                  sx={{ 
                    fontFamily: "Inter",
                    fontSize: "14px",
                    color: "white"
                  }}
                >
                 Contact Per Page
                </Typography>

                {/* Button */}
                <Button
                  onClick={handleOpen}
                  sx={{
                    color: pageSize ? "rgba(255, 255, 255, 1)" : "rgba(202, 196, 208, 1)",
                    backgroundColor: "#2F355F",
                    borderRadius: "8px",
                    height: "42px",
                    minWidth: "120px",
                    textTransform: 'none',
                    fontFamily: "Inter",
                    fontWeight: 400,
                    '&:hover': {
                      backgroundColor: "#373E6D",
                    },
                  }}
                >
                  {pageSize || "Per Page Item"}
                  <ArrowDropDownIcon 
                    sx={{ 
                      color: pageSize ? "rgba(255, 255, 255, 1)" : "rgba(202, 196, 208, 1)", 
                      marginLeft: "auto" 
                    }} 
                  />
                </Button>
              </Box>


              <Popover
                open={opendropdown}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                sx={{
                  '& .MuiPaper-root': {
                    backgroundColor: "#2F355F",
                    color: "white",
                    borderRadius: "8px",
                    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.2)",
                    maxHeight: "300px",
                    width: "180px",
                    marginTop: "4px"
                  },
                }}
              >
                <Box sx={{ overflowY: 'auto', maxHeight: 250 }}>
                  {perPageItem?.map((ele) => (
                    <MenuItem
                      key={ele.id}
                      onClick={() => { setPageSize(ele.value); handleClose() }}
                      sx={{
                        '&:hover': { backgroundColor: "#373E6D" },
                        '&.Mui-selected': { backgroundColor: "#373E6D" },
                        py: 1,
                        fontSize: 14,
                      }}
                    >
                      {ele.value}
                    </MenuItem>
                  ))}
                </Box>
              </Popover>
            </FormControl>
          </Box>

          <Box sx={{ display:"flex", flexDirection:"row", justifyContent:"space-between", borderRadius:"16px" ,backgroundColor:"#171A2D",padding:"16px 30px",  marginTop: "40px", }}>
            <Box sx={{display:"flex", flexDirection:"row", alignItems:"center", columnGap:"32px"}}>
            <Checkbox
                          checked={selectedContacts?.length}
                          onChange={handleSelectAll}
                          sx={{ color: "#ffffff",'&.Mui-checked': { color: "#CAC4D0", }, marginLeft:"15px"}}
            /> 
            <Typography sx={{fontFamily:"Inter", fontSize:"16px", fontStyle:"normal", fontWeight:500, lineHeight:"28px", color:"#CAC4D0"}}>{`${selectedContacts?.length} of ${contactData?.length} selected on page`} </Typography> 
            {/* <Box sx={{display:"flex", flexDirection:"row", columnGap:"8px", alignItems:"center"}}>
            <Typography sx={{fontFamily:"Inter", fontSize:"14px", fontStyle:"normal", fontWeight:600, lineHeight:"28px", color:"rgba(255, 255, 255, 0.90)", textDecorationLine:"underline", textDecorationStyle:"solid", textDecorationSkipInk:"none", textDecorationThickness:"auto", textUnderlineOffset:"auto", textUnderlinePosition:"from-font"}}>Select all contacts</Typography> 
              <InfoOutlinedIcon sx={{color:"rgba(255, 255, 255, 0.80)"}}/>
              <Typography sx={{color:"rgba(255, 255, 255, 0.80)", fontFamily:"Inter", fontSize:"12px", fontStyle:"normal", fontWeight:400, lineHeight:"20px"}}>Up to 100</Typography>
            </Box> */}
            

            </Box>
            <Box sx={{display:"flex", flexDirection:"row", columnGap:"12px"}}>    
                  <Button  onClick={handleBulkCallButtonClick} disabled={selectedContacts?.length===0 || selectedContacts?.length===undefined} // onClick={handleCallSelectedUser}
                                              sx={{
                                                  display: "flex",
                                                  justifyContent: "space-around",
                                                  textTransform: "none",
                                                  padding: "8px 12px 8px 12px",
                                                  gap: "10px",
                                                  bgcolor: "#282D51",
                                                  textWrap:"nowrap",
                                                  borderRadius: "8px",
                                                  "&:hover": { bgcolor: "#373E6D" },
                                                  "&:active": { bgcolor: "#2F355F"}
                                              }}
                                          >
                                              <Box sx={{ width: "17px", display: "flex", justifyContent: "center", alignItems: "center", color: "#FFFFFF", }}>
                                                  <LocalPhoneIcon sx={{ width: "18px", height: "18px", color:  selectedContacts?.length===0 ? "rgba(255, 255, 255, 0.40)" : "#FFFFFF",}}/>
                                              </Box>
                                              <Box sx={{  height: "20px" }}>
                                                  <Typography
                                                      sx={{
                                                          fontFamily: "Inter",
                                                          fontStyle: "normal",
                                                          fontSize: "14px",
                                                          fontWeight: 400,
                                                          lineHeight: "20px",
                                                          color:  selectedContacts?.length===0 ? "rgba(255, 255, 255, 0.40)" : "#FFFFFF",
                                                      }}> Call selected</Typography>
                                              </Box>
                                          </Button>  
                                          <Button   onClick={handleDeleteAllButtonClick}   disabled={selectedContacts?.length===0 && selectedContacts === undefined} //    onClick={handleDeleteSelectedUser} 
                                              sx={{
                                                  display: "flex",
                                                  justifyContent: "space-around",
                                                  textTransform: "none",
                                                  padding: "8px 12px 8px 12px",
                                                  gap: "10px",
                                                  bgcolor: "#282D51",
                                                  textWrap:"nowrap",
                                                  borderRadius: "8px",
                                                  "&:hover": { bgcolor: "#373E6D" },
                                                  "&:active": { bgcolor: "#2F355F"}
                                              }}
                                          >
                                              <Box sx={{ width: "17px", display: "flex", justifyContent: "center", alignItems: "center", color: "#FFFFFF", }}>
                                                  <DeleteIcon sx={{ width: "18px", height: "18px", color:  selectedContacts?.length===0 ? "rgba(255, 255, 255, 0.40)" : "#FFFFFF", }}/>
                                              </Box>
                                              <Box sx={{  height: "20px" }}>
                                                  <Typography
                                                      sx={{
                                                          fontFamily: "Inter",
                                                          fontStyle: "normal",
                                                          fontSize: "14px",
                                                          fontWeight: 400,
                                                          lineHeight: "20px",
                                                          color:  selectedContacts?.length===0 ? "rgba(255, 255, 255, 0.40)" : "#FFFFFF",
                                                      }}>Delete selected</Typography>
                                              </Box>
                                          </Button> 
            </Box>
             </Box>

          {/* Contacts content goes here */}
          <Box
            sx={{
              border: "1px solid rgba(255, 255, 255, 0.10)",
              display: "flex", 
              flexDirection: "column",
              width: "100%",
              backgroundColor: "#171A2D",
              marginTop: "20px",
              padding: "20px",
              borderRadius: "16px",
              maxHeight:"600px",
              overflowY:"auto"
            }}
          >
            
            <Box>
            {
                  loading ? 
                 <CircularLoader  msg={"Loading Contacts..."} /> 
                :
              <div>
              <TableContainer>
                <Table sx={{ fontFamily: "Inter", color: "#ffffff", }}>
                  <TableHead>
                    <TableRow>
                    <TableCell padding="checkbox" sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}>
                          <Tooltip
                            componentsProps={{
                              tooltip: {
                                sx: {
                                                            bgcolor: "#E6E0E9",
                                                            color: "#17182C",
                                                            fontFamily: "Inter",
                                                            fontSize: "12px",
                                                            fontWeight: 500,
                                                            padding: "4px 8px 4px 8px",
                                                            borderRadius: "4px",
                                                            textAlign: "center",
                                                        },
                                                    },
                                                }}
                            title={`Select All`}
                          >
                        <Checkbox
                          checked={isAllSelected}
                          onChange={handleSelectAll}
                          sx={{ color: "#ffffff",'&.Mui-checked': { color: "#CAC4D0", }, }}
                        /></Tooltip>
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Email
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Phone
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Custom attributes
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          maxWidth: "120px",
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "16px 20px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Updated at
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}
                      >
                        Actions
                      </TableCell>
                    </TableRow>
                  </TableHead>
                
                  <TableBody sx={{overflowY:"auto"}}>
                    {contactData?.map((row, index) => (
                      <TableRow
                        key={row.id}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                          cursor: "pointer",
                        }}
                      >
                        <TableCell padding="checkbox" sx={{
                          fontFamily: "Inter",
                          color: "#ffffff",
                          padding: "20px 24px",
                          borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                        }}>
                          <Checkbox
                            checked={selectedContactsId?.includes(row.id)}
                            onChange={(e) => handleSelectContact(e, row)}
                            sx={{ color: "#ffffff",  '&.Mui-checked': { color: "#CAC4D0", }, }}
                          /></TableCell>
                        <TableCell onClick={(e)=>HandleClickOnUser(e,row)}
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#CAC4D0",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                            fontSize:"16px", 
                            fontStyle:"normal", 
                            fontWeight:600,
                            lineHeight:"28px",
                            '&:hover':{color:"#CAC4DO", opacity:0.8}
                          }}
                        >
                          {row?.name}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row?.email}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {row?.phone?.e164}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {convertObjectToTextFormat(row?.custom_attributes)}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            maxWidth: "12px",
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          {formatDateTime(row?.updated_at)}
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              columnGap: "16px",
                            }}
                          >
                            <Button disabled={loadingId !== null} onClick={(e)=>{setLoadingId(row.id); HandleVoiceCallClick(e, row)}}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: "50%",
                                alignItems: "center",
                                maxWidth: "36px",
                                minWidth: "36px",
                                height: "36px",
                                bgcolor: "#1F233E",
                                padding: "8px",
                              }}
                            >
                              {
                                phoneCallTriggerdloading && row.id == loadingId ?  <CircularProgress size={"20px"} sx={{width:"10px", height:"10px", color:"#ffffff"}}/> 
                                :
                              <LocalPhoneIcon
                                sx={{
                                  color: "#CAC4D0",
                                  width: "20px",
                                  height: "20px",
                                }}
                              />
                              }
                            </Button>
                            <Button onClick={(e)=>{HandleWebCallClick(e)}}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: "50%",
                                alignItems: "center",
                                maxWidth: "36px",
                                minWidth: "36px",
                                height: "36px",
                                bgcolor: "#1F233E",
                                padding: "8px",
                              }}
                            >
                              <PhoneInTalkOutlinedIcon
                                sx={{
                                  color: "#CAC4D0",
                                  width: "20px",
                                  height: "20px",
                                  bgcolor: "#1F233E",
                                }}
                              />
                            </Button>
                            <Button
                              onClick={(e)=>HandleMoreOptionInActionClick(e, row)}
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                borderRadius: "50%",
                                alignItems: "center",
                                maxWidth: "36px",
                                minWidth: "36px",
                                height: "36px",
                                bgcolor: "#1F233E",
                                padding: "8px",
                              }}
                            >
                              <MoreVertOutlinedIcon
                                sx={{
                                  color: "#CAC4D0",
                                  width: "20px",
                                  height: "20px",
                                  bgcolor: "#1F233E",
                                }}
                              />
                            </Button>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              </div>
}
            </Box>
          </Box>
          <div className="d-flex justify-content-center mt-3">
            <ThemeProvider theme={theme}>
              <Pagination
                count={totalPages} // Total number of pages
                page={currentPage} // Current page
                siblingCount={1} // Show one previous and one upcoming page
                boundaryCount={1} // Show first and last page buttons
                onChange={handlePageChange} // Handle page change
                shape="rounded" // Rounded buttons
                size="large" // Larger buttons
              />
            </ThemeProvider>
          </div>
          <CommonMoreActionOptionModal
            showModal={moreActionOption}
            setShowModal={setMoreActionOption}
            options={userOptions}
            setOpenDeleteConformationModal={setOpenDeleteConformationModal}
            openEditedModal={setopenAddContactModal}
            setActiveUserObject={setActiveUserObject}
            activeUserObject={activeUserObject}
          />
          {openAddContactModal && <ModalForContacts
            openAddAgentModal={openAddContactModal}
            setOpenAddAgentModal={setopenAddContactModal}
            handleClose={HandleCloseButtonClick}
            fetchData={getcontactsData}
            activeUserObject={activeUserObject}
            setMoreActionOption={setMoreActionOption}
            ButtonClick={buttonClick}
          />}
          <ModalForContactSetup
            showContactSetupModal={showContactSetupModal}
            handleClose={HandleContactSettingModalClose}
          />

          <CommonToast
            open={open}
            onClose={handleToastClose}
            content={content}
            iconType={iconType}
            bgColor={"#282D51"}
          />
          <CommanModalForConformation open={openDeleteConformationModal} modalTitle={deleteModalTitle} modalMessage={deleteModalMsg} handleConfirm={HandleConfirmDeleteContactAgent} handleCancel={HandleCancelDeleteContactAgent} confirmTitle={confirmTitle} loading={loading}/>
          <VoiceCallOptionModal/>
          <BulkCallConformationModal showModal={openBulkCallConformationModal} handleCloseModal={handleCloseBulkCallConformationModal} callCount={selectedContacts?.length} triggerCall={handleCallSelectedUser} loading={loading}/>
          <PreviousCallContactModal showModal={showPreviousCallModal} handleCloseModal={handleClosePreviousCalledContactModal} triggerCall={handleCallSelectedUser} loading={loading}  DeselectCallTriggeredContacts={handleDeselectTriggeredContacts} setAllowRecalling={setAllowRecalling}/>
        </div>
      )}
    </>
  );
};

export default Contacts;
